import { NavigationOptions } from 'interfaces';
import AppRoutes from './routes';
import { customEvent } from '@/lib';

/**
 * In this const file should be placed all const related to header,
 * for example the options that should be rendered
 *
 * At first, header can have a single default options array as they will be filtered
 * by roles/permissions. But you can have more than one possible header options
 * (for this case you should make a builder function like the ones that were provided)
 *
 * An example of having multiple const options for header is when you have two different
 * sections on the page, lets say a web2 and web3 for example
 */

// Options to show on the user profile menu in the navbar header
export const headerUserProfileOptions: NavigationOptions[] = [];

// Normal navbar options, normally just text
// Updated headerNavbarOptions

export const headerClientAppOptions: NavigationOptions[] = [
	{
		name: 'dashboard',
		label: 'Dashboard',
		href: AppRoutes.CLIENTAPP_DASHBOARD,
	},
	{
		name: 'dashboard',
		label: 'Dashboard',
		href: '/lawyer',
	},
	{
		name: 'my-cases',
		label: 'My Cases',
		href: AppRoutes.CLIENTAPP_MY_CASES,
	},
	{
		name: 'my-cases',
		label: 'My Cases',
		href: `${AppRoutes.CLIENTAPP_MY_CASES}/[id]`,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: AppRoutes.CLIENTAPP_INBOX,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: `${AppRoutes.CLIENTAPP_INBOX}/[id]`,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: '/lawyer/inbox',
	},
	{
		name: 'financial-recovery',
		label: 'Financial Recovery',
		href: AppRoutes.CLIENTAPP_FINANCIAL_RECOVERY,
	},
	{
		name: 'claim-chat',
		label: 'Claim Chat',
		href: AppRoutes.CLIENTAPP_CLAIM_CHAT,
	},
	{
		name: 'settings',
		label: 'Settings',
		href: AppRoutes.CLIENTAPP_SETTINGS,
	},
	{
		name: 'complaint',
		label: 'Complaint',
		href: '/clientapp/documents/complaint/[id]',
	},
	{
		name: 'demand-letter',
		label: 'Demand Letter',
		href: '/clientapp/documents/demand-letter/[id]',
	},

	{
		name: 'inbox',
		label: 'Inbox',
		href: AppRoutes.LAWYERAPP_INBOX,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: `${AppRoutes.LAWYERAPP_INBOX}/[id]`,
	},
	{
		name: 'customer-support',
		label: 'Customer Support',
		href: AppRoutes.CLIENTAPP_CUSTOMER_SUPPORT,
	},
];

export const headerLawyerAppOptions: NavigationOptions[] = [
	{
		name: 'dashboard',
		label: 'Dashboard',
		href: AppRoutes.LAWYERAPP_DASHBOARD,
	},
	{
		name: 'new-case',
		label: 'New Case',
		href: `${AppRoutes.LAWYERAPP_CASES}/create`,
	},
	{
		name: 'cases',
		label: 'Cases',
		href: AppRoutes.LAWYERAPP_CASES,
	},
	{
		name: 'cases',
		label: 'Cases',
		href: `${AppRoutes.LAWYERAPP_CASES}/[id]`,
	},
	{
		name: 'client-directory',
		label: 'Client Directory',
		href: AppRoutes.LAWYERAPP_CLIENT_DIRECTORY,
	},
	{
		name: 'client-directory',
		label: 'Client Directory',
		href: AppRoutes.LAWYERAPP_CLIENT_PROFILE_ID,
	},
	{
		name: 'cleanup-wizard',
		label: 'Client Directory',
		href: AppRoutes.LAWYERAPP_CLIENT_DIRECTORY_CLEANUP_WIZARD,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: AppRoutes.LAWYERAPP_INBOX,
	},
	{
		name: 'analytics',
		label: 'Analytics',
		href: AppRoutes.LAWYERAPP_CLIENT_ANALYTICS,
	},
	{
		name: 'client-targeting',
		label: 'Targeting',
		href: AppRoutes.LAWYERAPP_MARKETING_CLIENT_TARGETING,
	},
	{
		name: 'marketing',
		label: 'Marketing Campaigns',
		href: AppRoutes.LAWYERAPP_MARKETING,
	},
	{
		name: 'marketing',
		label: 'Marketing Campaigns',
		href: AppRoutes.LAWYERAPP_MARKETING_NEW_CAMPAIGN,
	},
	{
		name: 'marketing',
		label: 'Marketing Campaigns',
		href: `${AppRoutes.LAWYERAPP_MARKETING_CAMPAIGN}/[id]`,
	},
	{
		name: 'marketing',
		label: 'Marketing Campaigns',
		href: AppRoutes.LAWYERAPP_MARKETING_CAMPAIGN_SCHEDULE,
	},
	{
		name: 'performance',
		label: 'Performance',
		href: AppRoutes.LAWYERAPP_MARKETING_PERFORMANCE,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: `${AppRoutes.LAWYERAPP_INBOX}/[id]`,
	},
	{
		name: 'settings',
		label: 'Settings',
		href: AppRoutes.LAWYERAPP_SETTINGS,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: AppRoutes.LAWYERAPP_INBOX,
	},
	{
		name: 'inbox',
		label: 'Inbox',
		href: `${AppRoutes.LAWYERAPP_INBOX}/[id]`,
	},
	{
		name: 'admin',
		label: 'Admin',
		href: AppRoutes.LAWYERAPP_ADMIN_PANEL,
	},
];

export const headerNavbarOptions: NavigationOptions[] = [
	{
		name: 'my-cases',
		label: 'Explore Cases',
		href: AppRoutes.LANDING_CASES,
		onClick: () => {
			customEvent({
				action: 'explore_all_cases_click',
				category: 'landing',
				label: 'Explore All Cases',
				value: 'Explore All Cases',
			});
		},
	},
	{
		name: 'about',
		label: 'About Us',
		href: AppRoutes.LANDING_ABOUT_US,
	},
	{
		name: 'contact-us',
		label: 'Contact Us',
		href: AppRoutes.LANDING_CONTACT_US,
		onClick: () => {
			customEvent({
				action: 'contact_us_click',
				category: 'landing',
				label: 'Contact Us',
				value: 'Contact Us',
			});
		},
	},
];
